import { IItemModifierGroupsResponseData } from 'src/api/getModifierGroups';
import {
  IItemModifierGroupResponseDataModifiers,
  ItemModifierGroupsResponseBody,
} from 'src/api/getModifierGroups/types';
import { TOptionGroupRecord, TOptionGroupRow } from './types';

export const mapFieldValueToPrice = ([key, value]: [string, TOptionGroupRecord]) => {
  const price_id = value.price_id ?? null;
  const inherit_price = value.inherit_price ?? false;
  const value_with_tax = value.value_with_tax ? Number.parseFloat(value.value_with_tax) : null;

  return {
    price_id: price_id,
    value_with_tax: inherit_price ? null : value_with_tax,
    modifier_id: key,
    price_band_id: null,
    external_system_id: null,
  };
};

export const generateModifierFormDefaults = (
  modifiers: IItemModifierGroupResponseDataModifiers[],
): Record<string, Omit<IItemModifierGroupResponseDataModifiers, 'modifier_id'>> => {
  const entries = modifiers.map((modifier) => {
    const { modifier_id, price_id, value_with_tax, inherit_price } = modifier;
    return [
      modifier_id,
      {
        price_id,
        value_with_tax,
        inherit_price,
      },
    ];
  });

  return Object.fromEntries(entries);
};

export const flattenPagesToModifiers = (pages: ItemModifierGroupsResponseBody[] = []) => {
  const flattenedPages = pages?.flatMap(({ data }) => data) ?? [];

  return flattenedPages.flatMap((group) => group.modifier_groups).flatMap((modifier_group) => modifier_group.modifiers);
};

export const mapModifierGroupToTableRow = (item: IItemModifierGroupsResponseData): TOptionGroupRow => {
  return {
    item_id: item.item_id,
    name: item.name,
    type: item.type,
    ranges: item.ranges,
    modifiers: item.modifier_groups.map((nested) => ({
      name: nested.name,
      publish_channels: nested.external_systems,
      modifiers: nested.modifiers.map((modifier) => ({
        name: modifier.name,
        price_id: modifier.price_id,
        modifier_id: modifier.modifier_id,
        inherit_price: modifier.inherit_price,
        ranges: modifier.ranges,
        value_with_tax: String(modifier.value_with_tax),
      })),
    })),
  };
};
